import React, { useEffect, useState, useRef, forwardRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { AddEvent, UpdateEvent, GetCharge, GetEventInvoices } from '../../REST/cameraEvents';
import { FormView, Field } from '../../components/form/Index';
import Button from '@material-ui/core/Button'
import { isEqual } from '../Statements/receipt';
import Company from './company';
import { authenticationService } from '../../components/authorization';
import CreateInvoice from '../Statements/create';
import { useImperativeHandle } from 'react';
import MessageView from '../../components/message';
import DefaultSettings from '../../components/settings';

function DetailsView({ editable = true, entity, onRefresh, options = { companies: [], skus: [], charges: [], cameras: [] } }, ref) {
    const { id } = useParams();
    const [event, setEvent] = useState(null);
    const [initialEvent, setIntialEvent] = useState(null)
    const [error, setError] = useState(null);
    const [disable, setDisable] = useState(false);
    const [create, setCreate] = useState({ open: false, eventIds: [], groupSimilar: false })
    const [add, setAdd] = useState(false);
    const formView = useRef(null)
    const history = useHistory();

    useImperativeHandle(ref, () => ({
        validate: () => {
            let result = formView.current.getResult();
            if (result) {
                setError(false);
                return Promise.resolve()
            }
            else {
                return Promise.reject();
            }
        },
        submit: () => {
            return Promise.resolve()
        }
    }))


    useEffect(() => {
        if (entity && entity !== null) {
            GetEventInvoices(entity.id).then(response => {
                setEvent(entity)
                setIntialEvent(entity)
                let tempDisable = ((options.cameras.find(each => each.value.toString() === entity.cameraId.toString()).label).toUpperCase()).includes('Exit'.toUpperCase());
                setDisable((response.data.length > 0 || tempDisable) ? true : false)
            })
        }
    }, [])//entity, options.cameras

    const transport = [
        { label: 'Air Craft', value: 1 },
        { label: 'Commercial Ground', value: 2 }
    ]

    const handleChange = () => {
        let result = formView.current.getCurrentResult();
        setEvent({ ...event, ...result })
        // onRefresh();
    }

    const handleClose = (refresh) => {
        setAdd(false)
        if (refresh) onRefresh();
    }

    const handleCharge = () => {
        let result = formView.current.getCurrentResult();
        const sku = options.charges.find(e => isEqual(e.skuId, result.skuId));
        if (sku) {
            result.charge = sku.nonPermitAmount
            setEvent({ ...event, ...result })
        }
    }

    const handleCreate = (invoiceIds) => {
        if (Array.isArray(invoiceIds) && invoiceIds.length > 0)
            history.push('/invoices/' + invoiceIds[0])
    }

    const handleSave = () => {
        let result = formView.current.getResult();
        console.log(result);
        if (result) {
            if (id !== 0 && id && id !== '0') {
                UpdateEvent({ ...initialEvent, ...event, ...result }).then(response => {
                    setEvent(response.data)
                    setDisable(false)
                })
            }
            else {
                AddEvent({ ...result, status: 1 }).then(response => {
                    history.push('/events/' + response.data.id)
                })
            }
        }
    }

    const handleAdd = () => {
        let result = formView.current.getCurrentResult();
        setEvent({ ...event, ...result });
        setAdd(true)
    }

    const findCharge = () => {
        let result = formView.current.getCurrentResult();
        const sku = options.charges.find(e => isEqual(e.skuId, result.skuId));
        if (sku) {
            const { permitAmount, nonPermitAmount } = sku;
            const { plateNumber, plateRegion, skuId } = result;
            const entity = { plateNumber, plateRegion, skuId, permitAmount, nonPermitAmount };
           
            if(entity.plateNumber=="" || !entity.plateNumber || !entity.plateRegion || entity.plateRegion==null) {
                if (DefaultSettings.getAlert())
                DefaultSettings.getAlert().show("Please enter PlateNumber  and Plate Region", 'error');   
            }else{
                GetCharge(entity,id).then(resp => {
                    setEvent({ ...result, ...resp.data })
                    onRefresh();
                }).catch(ex => {
                    
                    let erromessage = ex.response.data.value.Message;
    
                   let erroarr = erromessage.split("-");
    
                    let eres= event;
                    eres['companyId'] = erroarr[1];
                    setEvent({ ...eres })
                    if (DefaultSettings.getAlert() && ex)
                        DefaultSettings.getAlert().show(erroarr[0], 'error');             
    
                })
            }
           
        }
    }

    const createReq = (group) => {
        let result = formView.current.getResult();
        if (result)
            setCreate({ open: true, eventIds: [id], groupSimilar: group })
        else
            setTimeout(() => {
                console.log('Waiting')
                setDisable(true)
            }, 2000)
    }



    return <div className='row'>
        <Company open={add} handleClose={handleClose} states={states} />
        <CreateInvoice open={create.open} handleClose={() => setCreate({ open: false, eventIds: [], groupSimilar: false })} eventIds={create.eventIds} groupSimilar={create.groupSimilar} onCreated={handleCreate} />
        {id !== 0 && id !== '0' && authenticationService.isAdmin() && editable && <div className='col-12'>
            <Button disabled={(event || {}).status === 0 ? true : disable} onClick={() => createReq(false)}>Create Invoice For This Event</Button>
            <Button disabled={(event || {}).status === 0 ? true : disable} onClick={() => createReq(true)}>Create Invoice For This Transport</Button>
        </div>}
        {error && <p className='text-danger'>Please Submit all the required fields</p>}
        <div className='col-sm-12 col-md-6'>
            <FormView disabled={!editable} ref={formView} data={event}>
                <Field.DropDown changeEvt={handleCharge} field='skuId' label='Activity Type' options={options.skus} required />
                <Field.AmountText field='charge' label='Activity Charge' /> 
                <Field.DateTimePicker field='activityTime' label='Activity Time' required />
                <div className='row'>
                    <div className='col-6'>
                        {event && event.imageUid && <MessageView variant='text' fullScreen title='Reference Image' link={`https://gcn-camera.s3.amazonaws.com/${event.imageUid}_context.jpg`} />}
                    </div>
                    <div className='col-6'>
                        {event && event.imageUid && <MessageView variant='text' fullScreen title='Plate Image' link={`https://gcn-camera.s3.amazonaws.com/${event.imageUid}_plate.jpg`} />}
                    </div>
                </div>
                <Field.DropDown changeEvt={handleChange} field='vehicleType' label='Transport Type' options={transport} required />
                <Field.DropDown options={options.cameras} field='cameraId' label='Camera Name' required />
                <Field.TextBox field='companyDot' label='Notes (200 Chars)' />
                <div className='row'>
                    <Field.TextBox className='col' field='plateNumber' label={event && isEqual(event.vehicleType, 1) ? 'Tail Number' : 'Plate Number'} required />
                    {event && isEqual(event.vehicleType, 2) && <Field.DropDown className='col' label='Plate Region' field='plateRegion' options={states} required />}
                    {event && isEqual(event.vehicleType, 2) && <div className='col'><Button disabled={!editable} onClick={findCharge} fullWidth variant='outlined'>Search</Button></div>}
                </div>
                <div className='row'>
                    <Field.DropDown className='col' disabled={!authenticationService.isAdmin()} field='companyId' label='Company' options={options.companies} required />
                    {authenticationService.isAdmin() && editable && <Button className='col' onClick={() => handleAdd()} fullWidth variant='text'>Add New Company</Button>}
                </div>
                {editable && <div className='row'>
                    <div className='col-6'>
                        <Button color='secondary' onClick={handleSave} variant='outlined' fullWidth>Save</Button>
                    </div>
                    <div className='col-6'>
                        <Button color='secondary' href='#events' variant='outlined' fullWidth>Cancel</Button>
                    </div>
                </div>}
            </FormView>
        </div>
    </div>
}

export const states = [{ "label": "Alabama", "value": "AL" }, { "label": "Alaska", "value": "AK" }, { "label": "American Samoa", "value": "AS" }, { "label": "Arizona", "value": "AZ" }, { "label": "Arkansas", "value": "AR" }, { "label": "California", "value": "CA" }, { "label": "Colorado", "value": "CO" }, { "label": "Connecticut", "value": "CT" }, { "label": "Delaware", "value": "DE" }, { "label": "District Of Columbia", "value": "DC" }, { "label": "Federated States Of Micronesia", "value": "FM" }, { "label": "Florida", "value": "FL" }, { "label": "Georgia", "value": "GA" }, { "label": "Guam", "value": "GU" }, { "label": "Hawaii", "value": "HI" }, { "label": "Idaho", "value": "ID" }, { "label": "Illinois", "value": "IL" }, { "label": "Indiana", "value": "IN" }, { "label": "Iowa", "value": "IA" }, { "label": "Kansas", "value": "KS" }, { "label": "Kentucky", "value": "KY" }, { "label": "Louisiana", "value": "LA" }, { "label": "Maine", "value": "ME" }, { "label": "Marshall Islands", "value": "MH" }, { "label": "Maryland", "value": "MD" }, { "label": "Massachusetts", "value": "MA" }, { "label": "Michigan", "value": "MI" }, { "label": "Minnesota", "value": "MN" }, { "label": "Mississippi", "value": "MS" }, { "label": "Missouri", "value": "MO" }, { "label": "Montana", "value": "MT" }, { "label": "Nebraska", "value": "NE" }, { "label": "Nevada", "value": "NV" }, { "label": "New Hampshire", "value": "NH" }, { "label": "New Jersey", "value": "NJ" }, { "label": "New Mexico", "value": "NM" }, { "label": "New York", "value": "NY" }, { "label": "North Carolina", "value": "NC" }, { "label": "North Dakota", "value": "ND" }, { "label": "Northern Mariana Islands", "value": "MP" }, { "label": "Ohio", "value": "OH" }, { "label": "Oklahoma", "value": "OK" }, { "label": "Oregon", "value": "OR" }, { "label": "Palau", "value": "PW" }, { "label": "Pennsylvania", "value": "PA" }, { "label": "Puerto Rico", "value": "PR" }, { "label": "Rhode Island", "value": "RI" }, { "label": "South Carolina", "value": "SC" }, { "label": "South Dakota", "value": "SD" }, { "label": "Tennessee", "value": "TN" }, { "label": "Texas", "value": "TX" }, { "label": "Utah", "value": "UT" }, { "label": "Vermont", "value": "VT" }, { "label": "Virgin Islands", "value": "VI" }, { "label": "Virginia", "value": "VA" }, { "label": "Washington", "value": "WA" }, { "label": "West Virginia", "value": "WV" }, { "label": "Wisconsin", "value": "WI" }, { "label": "Wyoming", "value": "WY" }]

export default forwardRef(DetailsView);